// Dumb list — no store, no SQL. The page owns useCategorySummary and the
// reload trigger.
//
//   props:  categories    (Object) keyed by id -> { id, title, icon, sort }
//           subcategories (Object) keyed by id -> { id, title, categoryId, type }
//           statusCounts  (Object) keyed by categoryId -> { statuses, subcategories }
//                                  each status carries { count, titles, icon,
//                                  toolTip, statusColor, sort, isTerminal, link }
//           loading       (Boolean) shows the skeleton
//   emits:  none
import setup from './setup.js';

export default {
  name: 'category-subcategory-list',
  props: {
    categories: {
      type: Object,
      default: () => ({})
    },
    subcategories: {
      type: Object,
      default: () => ({})
    },
    statusCounts: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup,
};
